"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _immutable = require("immutable");

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _get = _interopRequireDefault(require("transmute/get"));

var DEFAULT_ICON_URL = 'https://hubspot-avatars.s3.amazonaws.com/default-80.png';

var formatPersonaReference = function formatPersonaReference(persona) {
  return new _ReferenceRecord.default({
    id: "persona_" + persona.id,
    label: persona.name,
    description: persona.label,
    icon: (0, _immutable.Map)({
      type: 'image',
      src: persona.imageUrl || DEFAULT_ICON_URL
    }),
    referencedObject: (0, _immutable.fromJS)(persona)
  });
};

var formatPersonas = function formatPersonas(personas) {
  return (0, _indexBy.default)((0, _get.default)('id'), (0, _immutable.List)(personas).map(formatPersonaReference));
};

var _default = formatPersonas;
exports.default = _default;
module.exports = exports.default;